export const story6 = `
{{You are more than a traveler. You are the bridge between violently opposed parties.[[x,x,x]]}}
{{With all elements fully powered, you can embrace the[[x,x,x]]}} {{Unity of Purpose<<Unity of Purpose>>[[100,100,100]]}}
`;
